"use client";
import React, { useState, useEffect, useRef, useCallback, use } from "react";
import { CiMenuFries } from "react-icons/ci";
import { motion, AnimatePresence } from "framer-motion";
import { HiMiniChevronRight } from "react-icons/hi2";
import { IconSettings, IconLogout2, IconReceipt2 } from "@tabler/icons-react";
import { useNavigate, useSearchParams } from "react-router-dom";

import Home from "./../Pages/Home/Home";
import Logo from "../assets/logo_1.png";
import home from "../assets/home.png";
import calendar from "../assets/calendar.png";
import clients from "../assets/clients.png";
import bussiness from "../assets/bussiness.png";
import chat from "../assets/chat.png";
import analytics from "../assets/analytics.png";
import invoice from "../assets/invoice.png";
import payments from "../assets/payments.png";
import marketplace from "../assets/marketplace.png";
import Analytics from "../Pages/Analytics/Analytics";
import Calendar from "../Calendar/Calendar";
import Clients from "../Pages/Clients/Clients";
import ExcludedClients from "../Pages/Clients/ExcludedClients";
import YourBusiness from "../Pages/YourBussiness/YourBussiness";
import Chat from "../Pages/Chat/Chat";
import Payment from "../Pages/Payment/Payment";
import Settings from "../Pages/Settings/Settings";
import Marketplace from "../Pages/Marketplace/Marketplace";
import Invoices from "../Pages/Invoices/Invoices";
import Taxes from "../Pages/Taxes/Taxes";
import { REST_API_URL } from "../api/config";
import { getHalperChatUnreadCount } from "../api/chat/chatServices";
const mainLinks = [
  { label: "Home", icon: home },
  { label: "Calendar", icon: calendar },
  { label: "Clients", icon: clients },
  { label: "Excluded contacts", icon: clients },
  { label: "Your business", icon: bussiness },
  { label: "Chat", icon: chat },
  { label: "Analytics", icon: analytics },
  { label: "Invoices", icon: invoice },
  { label: "Payments", icon: payments },
  { label: "Marketplace", icon: marketplace },
  { label: "Accounting", icon: IconReceipt2, iconComponent: true, badge: "New" },
];



const bottomLinks = [
  { label: "Settings", icon: IconSettings },
  // { label: "Support", icon: IconHeadset },
];

const API_URL = REST_API_URL;

const looksLikeJwt = (t) =>
  typeof t === "string" &&
  t &&
  t !== "undefined" &&
  t !== "null" &&
  t.split(".").length === 3;

const getUserTimeZone = () =>
  Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";

const buildHeaders = (token) => ({
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
  "User-Timezone": getUserTimeZone(),
});

const clearAuthStorage = () => {
  // Keys used by smartAxios interceptor (getToken/saveToken)
  localStorage.removeItem("access");
  localStorage.removeItem("refresh");

  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("user_status");
  localStorage.removeItem("halper_remember_me");
  localStorage.removeItem("halper_saved_email");
  localStorage.removeItem("last_login_time");
  localStorage.removeItem("login_timezone");
  localStorage.removeItem("user_timezone");
  localStorage.removeItem("analyticsCurrency");
  localStorage.removeItem("analyticsCurrencyTimestamp");

  sessionStorage.removeItem("accessToken");
  sessionStorage.removeItem("refreshToken");
  sessionStorage.removeItem("user_status");
  sessionStorage.removeItem("last_login_time");
  sessionStorage.removeItem("login_timezone");

  // Clean up tab-specific "should clear" flags (see main.jsx)
  Object.keys(localStorage)
    .filter((k) => k.startsWith("halper_should_clear_"))
    .forEach((k) => localStorage.removeItem(k));
};

export function SidebarDemo() {
  const [open, setOpen] = useState(true);
  const [activeLink, setActiveLink] = useState("Home");
  const [taxesLoaded, setTaxesLoaded] = useState(false);
  const [userInfo, setUserInfo] = useState(null);
  const [loadingUser, setLoadingUser] = useState(true);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [halperChatUnreadCount, setHalperChatUnreadCount] = useState(0);
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const dropdownRef = useRef(null);

  useEffect(() => {
    const section = searchParams.get("section");
    if (section) {
      setActiveLink(section);
    }
  }, [searchParams]);

  useEffect(() => {
    if (activeLink === "Accounting") setTaxesLoaded(true);
  }, [activeLink]);

  useEffect(() => {
    getHalperChatUnreadCount()
      .then((data) => setHalperChatUnreadCount(data.unread_count))
      .catch(console.error);
  }, [activeLink]);

  const fetchUserInfo = useCallback(async () => {
    const token =
      localStorage.getItem("accessToken") ||
      sessionStorage.getItem("accessToken");

    if (!looksLikeJwt(token)) {
      setUserInfo(null);
      setLoadingUser(false);
      return;
    }

    try {
      setLoadingUser(true);

      const headers = buildHeaders(token);
      const res = await fetch(`${API_URL}/auth/userinfo/`, { headers });

      if (res.status === 401) {
        clearAuthStorage();
        navigate("/sign-in", { replace: true });
        return;
      }

      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      const data = await res.json().catch(() => null);
      setUserInfo(data);
    } catch (err) {
      console.error("❌ Failed to fetch user info:", err);
      setUserInfo(null);
    } finally {
      setLoadingUser(false);
    }
  }, [navigate]);

  useEffect(() => {
    let cancelled = false;

    const run = async () => {
      if (cancelled) return;
      await fetchUserInfo();
    };

    run();

    const handler = () => fetchUserInfo();
    window.addEventListener("userUpdated", handler);

    return () => {
      cancelled = true;
      window.removeEventListener("userUpdated", handler);
    };
  }, [fetchUserInfo]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const user = userInfo?.user || {};
  const userName =
    [user.first_name, user.last_name].filter(Boolean).join(" ") ||
    user.email ||
    "User";

  const userAvatar =
    userInfo?.user?.image_url ||
    userInfo?.image ||
    userInfo?.avatar ||
    "https://i.sstatic.net/l60Hf.png";

  const handleSignOut = () => {
    clearAuthStorage();
    navigate("/sign-in", { replace: true });
  };

  return (
    <div className="flex h-screen w-full overflow-hidden bg-gray-50">
      <motion.div
        animate={{ width: open ? "auto" : 64 }}
        className="h-full border-r border-neutral-200 bg-white"
        transition={{ duration: 0.2, ease: "easeInOut" }}
      >
        <div className="flex h-full flex-col justify-between">
          <div>
            <div className="flex items-center justify-between p-4 w-full">
              <AnimatePresence>
                {open && (
                  <motion.img
                    src={Logo}
                    alt="Logo"
                    key="halper"
                    initial={{ opacity: 0, x: -10 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: -10 }}
                    transition={{ duration: 0.2 }}
                    className="max-w-[150px] h-auto object-contain w-full"
                  />
                )}
              </AnimatePresence>

              <button
                type="button"
                onClick={() => setOpen(!open)}
                className="text-neutral-700 hover:bg-neutral-100 p-1 rounded"
              >
                <CiMenuFries className="h-5 w-5" />
              </button>
            </div>

            <nav className="flex flex-col gap-1 px-2 mt-2">
              {mainLinks
                .filter((link) => {
                  if (
                    (link.label === "Marketplace" || link.label === "Accounting") &&
                    userInfo?.user?.status === "worker"
                  ) {
                    return false;
                  }
                  return true;
                })
                .map((link, idx) => {
                  const isActive = activeLink === link.label;
                  return (
                    <button
                      key={idx}
                      type="button"
                      onClick={() => {
                        setActiveLink(link.label);
                        setSearchParams({});
                      }}
                      className={`relative flex items-center justify-between gap-3 px-3 p-2.5 text-sm transition-all  ${
                        isActive
                          ? "bg-indigo-500 text-white font-medium rounded-xl"
                          : "text-neutral-700 hover:bg-neutral-100 rounded-md"
                      }`}
                    >
                      {isActive && (
                        <span className="absolute left-0 top-1/2 -translate-y-1/2 w-1 h-10 bg-[#615FF8] rounded-r -ml-2" />
                      )}
                      <div className="flex items-center gap-3 min-w-0">
                        {link.iconComponent ? (
                          <link.icon
                            className={`h-5 w-5 shrink-0 ${
                              isActive ? "text-white" : "text-neutral-500"
                            }`}
                          />
                        ) : (
                          <img
                            src={link.icon}
                            alt={link.label}
                            className={`h-5 w-5 shrink-0 ${
                              isActive ? "brightness-200" : "opacity-70"
                            }`}
                          />
                        )}
                        {open && <span>{link.label}</span>}
                        {open && link.badge && (
                          <span className="ml-1 inline-flex items-center px-2 py-0.5 text-xs font-semibold rounded-full bg-white text-indigo-600">
                            {link.badge}
                          </span>
                        )}
                      </div>
                      {/* Show unread badge only for Chat link, visually appealing */}

                      {link.label === "Chat" && halperChatUnreadCount > 0 &&
                        (open ? (
                          <span
                            className="ml-2 inline-flex items-center justify-center px-2 py-0.5 text-xs font-semibold rounded-full bg-red-500 text-white min-w-[20px] min-h-[20px]"
                            style={{ lineHeight: 1 }}
                            aria-label={`Unread messages: ${halperChatUnreadCount}`}
                          >
                            {halperChatUnreadCount > 99
                              ? "99+"
                              : halperChatUnreadCount}
                          </span>
                        ) : (
                          <span
                            className="absolute -top-[0px] -right-[0px] inline-flex items-center justify-center px-1.5 py-0.5 text-xs font-semibold  bg-red-500 rounded-full  text-white "
                            aria-label={`Unread messages: ${halperChatUnreadCount}`}
                          >
                            {halperChatUnreadCount > 99
                              ? "99+"
                              : halperChatUnreadCount}
                          </span>
                        ))}
                    </button>
                  );
                })}
            </nav>
          </div>

          <div className="mb-4 px-2 flex flex-col gap-1">
            {bottomLinks.map((link, idx) => {
              const Icon = link.icon;
              const isActive = activeLink === link.label;

              return (
                <button
                  key={idx}
                  type="button"
                  onClick={() => {
                    setActiveLink(link.label);
                    setSearchParams({});
                  }}
                  className={`relative flex items-center gap-3 px-3 py-2.5 text-sm transition-all w-full ${
                    isActive
                      ? "bg-indigo-500 text-white font-medium rounded-xl"
                      : "text-neutral-700 hover:bg-neutral-100 rounded-md"
                  }`}
                >
                  {isActive && (
                    <span className="absolute left-0 top-1/2 -translate-y-1/2 w-1 h-10 bg-[#615FF8] rounded-r -ml-2" />
                  )}
                  <Icon
                    className={`h-5 w-5 shrink-0 ${
                      isActive ? "text-white" : "text-neutral-500"
                    }`}
                  />
                  {open && <span>{link.label}</span>}
                </button>
              );
            })}

            <div className="relative" ref={dropdownRef}>
              <button
                type="button"
                onClick={() => setDropdownOpen(!dropdownOpen)}
                className="w-full px-3 py-2.5 mt-2 rounded-md text-sm text-neutral-700 hover:bg-neutral-100 transition-all flex items-center justify-between"
              >
                {loadingUser ? (
                  <span className="text-neutral-400">Loading...</span>
                ) : (
                  <>
                    <div className="flex items-center gap-3 min-w-0">
                      <img
                        src={userAvatar}
                        className="w-8 h-8 shrink-0 rounded-full object-cover"
                        alt="avatar"
                      />

                      {open && (
                        <span className="font-medium truncate max-w-[100px]">
                          {userName}
                        </span>
                      )}
                    </div>

                    {open && (
                      <HiMiniChevronRight
                        className={`transition-transform duration-200 ${
                          dropdownOpen ? "rotate-90" : ""
                        }`}
                      />
                    )}
                  </>
                )}
              </button>

              <AnimatePresence>
                {dropdownOpen && open && (
                  <motion.div
                    initial={{ opacity: 0, y: -5 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -5 }}
                    transition={{ duration: 0.15 }}
                    className="absolute bottom-14 left-3 w-[150px] bg-white border border-neutral-200 shadow-lg rounded-lg overflow-hidden z-20"
                  >
                    <button
                      type="button"
                      onClick={handleSignOut}
                      className="flex items-center gap-2 px-4 py-2 text-sm w-full text-left hover:bg-neutral-100 text-red-500"
                    >
                      <IconLogout2 className="h-4 w-4" /> Sign out
                    </button>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          </div>
        </div>
      </motion.div>

      <main className="flex flex-1 flex-col overflow-auto p-1">
        {activeLink === "Home" && <Home />}
        {activeLink === "Calendar" && <Calendar />}
        {activeLink === "Clients" && <Clients />}
        {activeLink === "Excluded contacts" && <ExcludedClients />}
        {activeLink === "Your business" && <YourBusiness />}
        {activeLink === "Chat" && <Chat />}
        {activeLink === "Analytics" && <Analytics />}
        {activeLink === "Payments" && <Payment />}
        {activeLink === "Settings" && (
          <Settings initialTab={searchParams.get("tab") ?? "user-info"} />
        )}
        {/* {activeLink === "Support" && <SupportChat />} */}
        {activeLink === "Marketplace" && <Marketplace />}
        {activeLink === "Invoices" && <Invoices />}
        {taxesLoaded && (
          <div
            className="flex flex-1 flex-col overflow-auto"
            style={{ display: activeLink === "Accounting" ? undefined : "none" }}
          >
            <Taxes />
          </div>
        )}
      </main>
    </div>
  );
}
